import React, { Component } from "react";

import { Link } from "react-router-dom";

import { connect } from "react-redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import ObliqueImage from "../assets/workouts/oblique.jpg";

class Landing extends Component {
  state = {
    menuToggled: false,
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  render() {
    return (
      <div>
        <div style={{ position: "relative" }}>
          {/*this.state.menuToggled ? <MenuFunc off={this.setmenuoff} /> : null*/}
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={{
            /* height: "800px",
            width: "450px",*/
            borderRadius: "20px",
            /*boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",*/
            /*backgroundColor: "#000",*/
          }}
        >
          <div style={{ padding: "55px 20px 20px 20px" }}>
            <h2>Oblique Workouts</h2>
            <div style={{ display: "flex" }}>
              <div className="notmobile">
                <img
                  src={ObliqueImage}
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="Session Obliques"
                />
              </div>

              <div className="notmobile">
                <img
                  src={ObliqueImage}
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="Session Obliques"
                />
              </div>

              <div className="notmobile">
                <img
                  src={ObliqueImage}
                  style={{ width: "100%", borderRadius: "3px" }}
                  alt="Session Obliques"
                />
              </div>
            </div>
            <p
              style={{
                fontSize: "18px",
                textAlign: "left",
                /*textJustify: "distribute",
                textAlignLast: "left",
                width: "100%",*/
              }}
            >
              Les muscles des obliques sont chargés de plusieurs fonctions. <br />
              <br />
              Si vous êtes en mouvement, vous avez besoin de ces muscles. Si vous voulez augmenter vos performances en fitness, vous aurez besoin de les muscler.
            </p>

            <p style={{ fontSize: "18px" }}>
              <button
                style={{
                  fontSize: "18px",
                  background: "#69C9D0",
                  padding: "10px",
                  border: 0,
                  borderRadius: "4px",
                  fontWeight: "600",
                  width: "100%",
                  color: "white",
                }}
              >
                Start Workout{" "}
                <span role="img" aria-label="like">
                  🔥
                </span>
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Landing);
